import React from 'react';
import { Table, Radio } from 'semantic-ui-react';
import { withCookies } from 'react-cookie';
import { withNamespaces } from 'react-i18next';


const ListItem = (props) => {
  const lang  =  props.cookies.get('lang') || 'et',
        { t, data, activeCompetitionId, onSelect, disabled } = props,
        isSelected = (data.id === activeCompetitionId),
        vacancies = data.participantLimit - data.participantCount;

  return (
    <Table.Row positive={isSelected} disabled={!vacancies}>
      <Table.Cell>
        <Radio
          disabled={disabled}
          competition={data}
          value={data.id}
          checked={isSelected}
          onChange={onSelect}
        />
      </Table.Cell>
      <Table.Cell>
        <b>{data.code} - {JSON.parse(data.i18n_title)[lang]}</b>
        <br/>
        {JSON.parse(data.i18n_description)[lang]}
      </Table.Cell>
      <Table.Cell singleLine>{data.beginTime} - {data.endTime}</Table.Cell>
      <Table.Cell>{vacancies}/{data.participantLimit}
      </Table.Cell>
      <Table.Cell>{data.organizer}</Table.Cell>
      <Table.Cell>
        <a href={data.competitionRulesURL}
           target='_blank'
           rel="noopener noreferrer">{t('private:addTeam.competitions.rules_read')}</a>
      </Table.Cell>
    </Table.Row>
  );
};

export default withNamespaces('private')(withCookies(ListItem));



// WEBPACK FOOTER //
// ./src/private/common/components/Workshop/Form/Competition/Competitions/Item.js